@let complete = completed$ | async;

@if (!complete) {
  <div class="w-full h-full flex flex-row items-center justify-center">
    <p-progress-spinner/>
  </div>
} @else {
  <homey-form-page
    [title]="'Success!'"
    [subtitle]="'Your can start applying again.'"
    [stepInfo]="null">
    <div class="mt-auto">
      <button pButton type="button" class="w-full" (click)="onContinue()"><span pButtonLabel>Continue</span></button>
    </div>
  </homey-form-page>
}
